export const apiUrl = {
  AUTH_LOGIN: "/v1/admin/login",
  AUTH_ME: "/v2/me/admin",
  AUTH_LOGOUT: "/v2/logout",
  GETALLECTURE: "/v3/lecture/",
  POSTLECTURE: "/v3/lecture",
  DELETELECTURE: "/v3/lecture",
  GET_LECTURE_BY_COURSE: "/v3/lecture/courseId",
  GET_INSTRUCTORS: "/v3/instructor",
  UPDATE_INSTRUCTOR: "/v3/instructor",
  DELETE_INSTRUCTOR: (id) => `/v3/instructor/${id}`,
  POSTCOURSE: "/v3/course",
  UPDATECOURSE: "/v3/course",
  DELETECOURSE: "/v3/course",
  GETCOURSES: "/v3/course",
  POST_BATCH: "/v3/batches",
  GET_BATCHES: "/v3/batches",
  UPDATE_BATCH: "/v3/batches",
  SOFT_DELETE_BATCH: "/v3/batches",
  HARD_DELETE_BATCH: "/v3/batches",
  // Attendance (v3 admin)
  ATTENDANCE_ROSTER: (batchId) => `/v3/attendance/batch/${batchId}/roster`,
  ATTENDANCE_MARK: (batchId) => `/v3/attendance/batch/${batchId}/mark`,
  EXTERNAL_ADMISSIONS: "/v3/attendance/external-admissions",
  MARK_ATTENDANCE_BY_NAME: "/v3/attendance/mark-by-name",
  // Enrollment (v3 admin)
  GET_ENROLLMENTS: "/v3/enrollment",
  CREATE_ENROLLMENT: "/v3/enrollment",
  TOGGLE_ENROLLMENT: (id) => `/v3/enrollment/${id}/toggle-status`,
  ADD_ENROLLMENT_PAYMENT: (id) => `/v3/enrollment/${id}/payments`,
  GET_ALL_STUDENTS: "/v3/student",
  //webinar (v3 admin)
  POST_WEBINAR: "/v3/webinar",
  GET_WEBINARS: "/v3/webinar",
  UPDATE_WEBINAR: (id) => `/v3/webinar/${id}`,
  GET_WEBINAR_REGISTRATIONS: "/v3/webinar",
  GET_REVIEWS: "/v3/review",
  DELETE_WEBINAR: (id) => `/v3/webinar/${id}`,
  CHECK_SLUG_AVAILABILITY: (slug) => `/v3/webinar/available-slug?slug=${slug}`,
  // Course Content (v3 admin)
  GET_COURSE_CONTENTS: "/v3/course-content",
  GET_COURSE_CONTENT_BY_ID: (id) => `/v3/course-content/${id}`,
  GET_COURSE_CONTENT_BY_COURSE: (courseId) =>
    `/v3/course-content/course/${courseId}`,
  POST_COURSE_CONTENT: "/v3/course-content",
  PATCH_COURSE_CONTENT: (id) => `/v3/course-content/${id}`,
  DELETE_COURSE_CONTENT: (id) => `/v3/course-content/${id}`,
  // Blog (v3 admin)
  GET_BLOGS: "/v3/blog",
  POST_BLOG: "/v3/blog",
  UPDATE_BLOG: (id) => `/v3/blog/${id}`,
  DELETE_BLOG: (id) => `/v3/blog/${id}`,
  LOGOUT: "/v2/logout",
  // Demo Video (v3 admin)
  GET_DEMO_VIDEOS: "/v3/demo-video",
  POST_DEMO_VIDEO: "/v3/demo-video",
  UPDATE_DEMO_VIDEO: (id) => `/v3/demo-video/${id}`,
  DELETE_DEMO_VIDEO: (id) => `/v3/demo-video/${id}`,
  // Placement (v3 admin)
  GET_PLACEMENTS: "/v3/placement",
  POST_PLACEMENT: "/v3/placement",
  UPDATE_PLACEMENT: (id) => `/v3/placement/${id}`,
  DELETE_PLACEMENT: (id) => `/v3/placement/${id}`,
  // Prebooking & Payment Tracking (v3 admin)
  GET_PREBOOKINGS: (params = {}) => {
    const sp = new URLSearchParams();
    if (params.page) sp.set("page", params.page);
    if (params.limit) sp.set("limit", params.limit);
    if (params.status) sp.set("status", params.status);
    if (params.search) sp.set("search", params.search);
    const qs = sp.toString();
    return `/v3/prebooking${qs ? `?${qs}` : ""}`;
  },
  PATCH_PREBOOKING: (id) => `/v3/prebooking/${id}`,
  // Video Review (v3 admin)
  GET_VIDEO_REVIEWS: "/v3/video-review",
  POST_VIDEO_REVIEW: "/v3/video-review",
  PATCH_VIDEO_REVIEW_APPROVE: (id) => `/v3/video-review/${id}/approve`,
  PATCH_VIDEO_REVIEW_REJECT: (id) => `/v3/video-review/${id}/reject`,
  DELETE_VIDEO_REVIEW: (id) => `/v3/video-review/${id}`,
  // Enquiry (v3 admin)
  GET_ENQUIRIES: "/v3/enquiry",
  // Jobs (v3 admin)
  GET_JOBS: "/v3/job",
  POST_JOB: "/v3/job",
  UPDATE_JOB: (id) => `/v3/job/${id}`,
  DELETE_JOB: (id) => `/v3/job/${id}`,

  // offer api routes
  GET_OFFER: "/v1/offer",
  POST_OFFER: "/v3/offer",

  // hire from us api routes
  GET_HIRE_FROM_US: "/v3/hire-from-us",

  // FAQ (v3 admin)
  GET_FAQS: "/v3/faq",
  POST_FAQ: "/v3/faq",
  BULK_FAQ: "/v3/faq/bulk",
  UPDATE_FAQ: (id) => `/v3/faq/${id}`,
  DELETE_FAQ: (id) => `/v3/faq/${id}`,
  REORDER_FAQS: "/v3/faq/reorder",

  UPDATE_OFFER: (id) => `/v3/offer/${id}`,
  DELETE_OFFER: (id) => `/v3/offer/${id}`,

  // Chatbot queries (v3 admin)
  GET_CHATBOT_QUERIES: "/v3/chatbot",
  GET_CHATBOT_LEADS: "/v3/chatbot/leads",
};

//pannel api routes
export const pannelApiUrl = {
  LOGIN_TO_PANNEL: "/user/login",
  ADMISSION: (limit = 10, page = 1, search = "") =>
    `/admission?limit=${limit}&page=${page}${search ? `&search=${encodeURIComponent(search)}` : ""}`,
};